/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Global_Toast_Success_DisabledInputs */

const es_components_credentials_global_toast_success_disabled = /** @type {(inputs: Components_Credentials_Global_Toast_Success_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credencial ya no es global`)
};

const en_components_credentials_global_toast_success_disabled = /** @type {(inputs: Components_Credentials_Global_Toast_Success_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credential is no longer global`)
};

/**
* | output |
* | --- |
* | "Credential is no longer global" |
*
* @param {Components_Credentials_Global_Toast_Success_DisabledInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_global_toast_success_disabled = /** @type {((inputs?: Components_Credentials_Global_Toast_Success_DisabledInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Global_Toast_Success_DisabledInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_global_toast_success_disabled(inputs)
	return en_components_credentials_global_toast_success_disabled(inputs)
});
export { components_credentials_global_toast_success_disabled as "components.credentials.global.toast.success_disabled" }